<template>
  <el-dialog :title="'订购会员'" :visible.sync="vipVisible" width="800px">
    <div v-loading="loading">
      <div>
        <h3 class="section-title">请选择会员等级</h3>
        <div class="plans-grid">
          <div v-for="item in levelList"
               :key="item.mer_shop_meb_level_id"
               :class="{ selected: vipInfo.level_id === item.mer_shop_meb_level_id,disabled: item.is_sales===1 }" class="plan-card" @click="selectLevel(item)">
            <div class="plan-header">
              <h4 class="plan-name">{{ item.meb_level_name }}</h4>
              <div class="plan-benefits">
                <p>{{ item.meb_level_describe }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt20">
        <h3 class="section-title">请选择会员套餐</h3>
        <div class="plans-grid">
          <div v-for="item in priceList" :key="item.mer_shop_meb_pricing_id" :class="{ selected: vipInfo.pricing_id === item.mer_shop_meb_pricing_id }"
               class="plan-card" @click="selectPrice(item)">
            <div class="plan-header">
              <h4 class="plan-name">{{ item.meb_duration_describe }}</h4>
              <div class="plan-benefits">
                <p>{{ item.meb_duration_days }}天</p>
              </div>
            </div>
            <div class="plan-price">
              <span class="price-number">{{ item.selling_price }}</span>
              <span class="price-unit">元</span>
              <span class="price-line">{{ item.original_price }}元</span>
            </div>
          </div>
        </div>
      </div>
      <div class="mt20">
        <h3 class="section-title">支付方式</h3>
        <div class="plans-grid">
          <div class="plan-card selected">
            <strong>余额支付</strong><span style="color: #999999">(当前可用余额 ¥{{ userInfo.money || 0 }})</span>
          </div>
        </div>
      </div>

      <div class="footer-box">
        <el-button @click="vipVisible=false">取消</el-button>
        <el-button type="primary" @click="handlePay">确认支付</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "orderMember",
  data() {
    return {
      vipVisible: false,
      vipInfo: {},
      levelList: [],
      priceList: [],
      loading: false,
      sLoading: false
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.login.userinfo,
    })
  },
  methods: {
    ...mapActions({
      getShopLevel: 'ucenter/getShopLevel',
      opOrderMember: 'ucenter/opOrderMember'
    }),
    //打开订购会员弹窗
    open(val) {
      this.vipVisible = true
      this.loading = true
      this.vipInfo = {shop_id: val.dd_shop_id, shop_name: val.shop_name,level_id:'',pricing_id:''}
      this.getShopLevel({
        data: {shop_id: val.dd_shop_id}, success: (res) => {
          this.loading = false
          if (res.code == 200) {
            this.levelList = res.data.list
            const salesList = this.levelList.filter(item => item.is_sales === 2)
            if(salesList.length){
              this.selectLevel(salesList[0])
            }
          } else {
            this.levelList =[]
            this.priceList=[]
            this.$message({message: res.message, type: 'error'})
          }
        }
      })
    },
    selectLevel(val) {
      this.$set(this.vipInfo,'level_id',val.mer_shop_meb_level_id)
      this.priceList = val.pricing
      this.vipInfo.pricing_id = this.priceList.length ? this.priceList[0].mer_shop_meb_pricing_id : ''
    },
    selectPrice(val){
      this.$set(this.vipInfo,'pricing_id',val.mer_shop_meb_pricing_id)
    },
    handlePay() {
      this.sLoading = true
      const params = {
        shop_id: this.vipInfo.shop_id,
        pricing_id: this.vipInfo.pricing_id
      }
      this.opOrderMember({
        data: params, success: (res) => {
          this.sLoading = false
          if (res.code === 200) {
            this.$message.success(res.message)
            this.vipVisible=false
            this.$emit('success')
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
  },
}
</script>


<style scoped>
.mt20 {
  margin-top: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 10px;
}

.plans-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.plans-grid .plan-card {
  border: 2px solid #e4e7ed;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.plans-grid .plan-card:hover {
  border-color: #ff6b35;
  box-shadow: 0 4px 12px rgba(255, 107, 53, 0.1);
}

.plans-grid .plan-card.selected {
  border-color: #ff6b35;
  background: #fff5f0;
}

.plans-grid .plan-card.disabled {
  background: #d0d3d3;
  opacity: 0.5;
  pointer-events: none;
}

.plans-grid .plan-card.recommended {
  border-color: #ff6b35;
}

.plans-grid .plan-card.recommended::before {
  content: '推荐';
  position: absolute;
  top: -1px;
  right: 12px;
  background: #ff6b35;
  color: white;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 0 0 8px 8px;
}

.plans-grid .plan-card .plan-header .plan-name {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 8px;
}

.plans-grid .plan-card .plan-header .plan-benefits p {
  font-size: 14px;
  color: #606266;
  margin: 0;
  line-height: 1.4;
}


.plans-grid .plan-card .plan-price {
  text-align: center;
  margin-top: 8px;
}

.plans-grid .plan-card .plan-price .price-number {
  font-size: 26px;
  font-weight: 700;
  color: #ff6b35;
}

.plans-grid .plan-card .plan-price .price-unit {
  font-size: 14px;
  color: #ff6b35;
  margin-left: 4px;
}

.plans-grid .plan-card .plan-price .price-line {
  font-size: 14px;
  color: #909399;
  margin-left: 4px;
  text-decoration: line-through;
}

.footer-box {
  margin-top: 20px;
  //display: flex;
  //justify-content: center;
  text-align: center;
}

</style>
